import { REGEX } from '@/constants/regex';
import { ILottieComponentProps } from '@/types/common';
import { replaceColor } from 'lottie-colorify';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useRef } from 'react';
import privateBankerAnimation from './lotties/PrivateBanker.json';

export const PrivateBankerLottie = ({ color = '' }: ILottieComponentProps) => {
  const isValidColor = new RegExp(REGEX.HEX_COLOR).test(color);
  const coloredPrivateBankerAnimation = isValidColor
    ? replaceColor([147, 149, 152], color, privateBankerAnimation)
    : privateBankerAnimation;
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleComplete = () => {
    lottieRef.current?.setDirection(-1);
    lottieRef.current?.play();
  };

  return (
    <Lottie
      lottieRef={lottieRef}
      style={{ height: '55px', marginBottom: '-10px', marginTop: '-5px' }}
      animationData={coloredPrivateBankerAnimation}
      loop={false}
      onComplete={handleComplete}
    />
  );
};
